import type { ReactNode } from 'react';
import { cn } from '../ui/utils';

type PageShellProps = {
  children: ReactNode;
  /**
   * Extra classes for the outer page wrapper.
   * Default: minimal top padding (header handled by app-shell) + bottom clearance above bottom nav.
   */
  className?: string;
};

export function PageShell({ children, className }: PageShellProps) {
  return <div className={cn('pb-bottom-nav-safe', className)}>{children}</div>;
}

